import {
  UpdateGfMerchantDto,
  GfMerchant,
} from "@swagger/typescript-fetch-goflyer";
import { toastError } from "../utils/pageUtil/toast";
import { messages } from "../locales/messages";
import { adminApiService } from "../utils/api";
import i18n from "i18next";
import { useLoading } from "../contextApi/LoadingContext";
import { useAuthHeaders } from "./useAuthHeaders";

export const useHandleSaveOnboardingMerchant = () => {
  const { showLoadingScreen } = useLoading();
  const authHeaders = useAuthHeaders();

  const handleSaveOnboardingMerchant = async (
    merchantData?: UpdateGfMerchantDto
  ): Promise<GfMerchant | null> => {
    try {
      if (!merchantData?.name) {
        toastError(`${i18n.t(messages.name())} ${i18n.t(messages.is_Empty())}`);
        return null;
      }
      if (!merchantData?.nameChinese) {
        toastError(
          `${i18n.t(messages.nameChinese())} ${i18n.t(messages.is_Empty())}`
        );
        return null;
      }
      if (!merchantData?.domain) {
        toastError(
          `${i18n.t(messages.domain())} ${i18n.t(messages.is_Empty())}`
        );
        return null;
      }

      if (!merchantData?.merchantLogo) {
        toastError(`${i18n.t(messages.logo())} ${i18n.t(messages.is_Empty())}`);
        return null;
      }

      showLoadingScreen(true);

      const savedMerchant =
        await adminApiService.gfMerchantAdminControllerOnBoardingCreateOne(
          {
            ...merchantData,
            name: merchantData.name,
            nameChinese: merchantData.name,
            domain: merchantData.domain,
            merchantMapLargeLogo: merchantData.merchantLogo,
            merchantLogo: undefined,
          },
          authHeaders
        );

      showLoadingScreen(false);

      return savedMerchant;
    } catch (error) {
      showLoadingScreen(false);

      const errorMessage = `${i18n.t(
        messages.There_is_an_error_please_Contact_Administrator()
      )}`;
      toastError(errorMessage);

      console.error("Error saving onboarding merchant:", error);
      return null;
    }
  };

  return handleSaveOnboardingMerchant;
};
